import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const ServiceOffert = lazy(() => import("@/pages/offert/ServiceOffert"));

export const Route = createFileRoute("/kommersiella-batterier/offert")({
  head: () => seoHead("/kommersiella-batterier/offert"),
  component: () => <ServiceOffert service="kommersiella-batterier" />,
});
